import * as React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/styles';

function ClearButton({ onChange, label, icon }) {
	const theme = useTheme();
	const { t } = useTranslation('common');
	return (
		<Stack direction="row" spacing={2}>
			<Button
				variant="text"
				role="button"
				data-testid="clear-button"
				startIcon={icon}
				onClick={() => {
					onChange([]);
				}}
				sx={{
					'&.MuiButton-text': {
						color: theme.palette.link.main,
						whiteSpace: 'nowrap',
					},
				}}
			>
				{t(`${label}`)}
			</Button>
		</Stack>
	);
}

ClearButton.propTypes = {
	onChange: PropTypes.func.isRequired,
	label: PropTypes.string.isRequired,
	icon: PropTypes.node,
};
export default ClearButton;
